import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ManagementAudioGetVolumeRequest,
	ManagementAudioGetVolumeResult,
	ManagementAudioRequests,
	ManagementAudioSetVolumeRequest,
	ManagementAudioSetVolumeResult,
} from './audioCommands';

export function handleManagementAudioRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementAudioRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementAudioRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementAudioGetVolumeRequest:
				await dispatch<ManagementAudioGetVolumeResult>({
					type: ManagementAudioGetVolumeResult,
					volume: await frontApplet.management.audio.getVolume(),
				});
				break;
			case ManagementAudioSetVolumeRequest:
				await frontApplet.management.audio.setVolume(commandEvent.command.volume);
				await dispatch<ManagementAudioSetVolumeResult>({
					type: ManagementAudioSetVolumeResult,
					result: {},
				});
				break;
			default:
		}
	});
}
